import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { GET_ALL_EVENTS, GET_ALL_EVENTS_RESPONSE_SUCCESS } from "./actionTypes"

import { getAllEventsCall } from "../../helpers/repository"
import { getAllEventsResponseSuccess } from "./actions"
import { showErrorMessages } from "../../helpers/helpers"
import { showMessage } from "../../components/Common/Toaster"
// import { apiError } from "store/actions"

function* attemptGetAllEvents() {
  try {
    const response = yield call(getAllEventsCall)
    yield put(getAllEventsResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* EventsSaga() {
  yield takeEvery(GET_ALL_EVENTS, attemptGetAllEvents)
}

export default EventsSaga
